import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_clsx_lite_e67b6d69__ from "clsx/lite";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__common_functions_mjs_3e3773ab__ from "../../../common/functions.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__icons_chevronRight_mjs_c19fa3e7__ from "../../icons/chevronRight.mjs";
const NavItem = ({ href, name, description, subNavItems = [], subNavDefaultOpen = false, asPrimary, config, openNewTab, eventParamsOverride = {}, navItemIcon })=>{
    const Element = href ? 'a' : 'button';
    const [showSubNav, setShowSubNav] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(subNavDefaultOpen);
    const renderChildMenuItem = (subNavItem, index, totalChildren)=>{
        const liClass = (0, __WEBPACK_EXTERNAL_MODULE_clsx_lite_e67b6d69__["default"])('ptw-bg-surface-light ptw-p-3 ptw-cursor-pointer', 0 === index && 1 === totalChildren && 'ptw-rounded', 0 === index && 1 !== totalChildren && 'ptw-rounded-t ptw-mb-1', index === totalChildren - 1 && 1 !== totalChildren && 'ptw-rounded-b', 0 !== index && index !== totalChildren - 1 && 'ptw-mb-1');
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("li", {
            className: liClass,
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("a", {
                href: subNavItem.href,
                className: "pds-h-5 ptw-box-border ptw-flex ptw-w-full ptw-list-none ptw-items-center ptw-justify-between ptw-border-none ptw-bg-utils-transparent ptw-text-left ptw-text-body-sm ptw-text-secondary-base ptw-no-underline hover:ptw-text-secondary-base",
                onClick: ()=>{
                    const defaultAction = ()=>{
                        setTimeout(()=>{
                            if (openNewTab) window.open(subNavItem.href);
                            else window.location.href = subNavItem.href;
                        }, 100);
                    };
                    defaultAction();
                },
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: "ptw-text-body-sm ptw-font-normal",
                        children: subNavItem.name
                    })
                })
            })
        }, `subnav-${index}`);
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(Element, {
                className: (0, __WEBPACK_EXTERNAL_MODULE_clsx_lite_e67b6d69__["default"])('ptw-box-border ptw-flex ptw-w-full ptw-cursor-pointer ptw-items-center ptw-justify-between ptw-border-none ptw-p-4 ptw-text-left ptw-text-body-md ptw-no-underline', asPrimary ? 'ptw-rounded ptw-bg-primary-base ptw-text-primary-text hover:ptw-text-primary-text' : 'ptw-bg-utils-transparent ptw-text-secondary-base hover:ptw-text-secondary-base'),
                ...href ? {
                    href
                } : {
                    type: 'button'
                },
                onClick: (e)=>{
                    e.preventDefault();
                    (0, __WEBPACK_EXTERNAL_MODULE__common_functions_mjs_3e3773ab__.sendIt)({
                        event: 'nav_click',
                        eventParams: {
                            nav_item: name,
                            nav_type: 'account',
                            ...eventParamsOverride
                        }
                    }, config.pup.dataLayerName, config.pup.logging);
                    if (href) setTimeout(()=>{
                        if (openNewTab) window.open(href);
                        else window.location.href = href;
                    }, 100);
                    else if ('button' === Element && subNavItems.length > 0) setShowSubNav(!showSubNav);
                },
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: "ptw-flex ptw-flex-grow ptw-flex-col ptw-text-left",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                className: "ptw-font-bold",
                                children: name
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                className: (0, __WEBPACK_EXTERNAL_MODULE_clsx_lite_e67b6d69__["default"])('ptw-text-body-sm', asPrimary ? 'ptw-text-primary-text' : 'ptw-text-surface-textSubdued'),
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: "ptw-width-[100px] ptw-flex",
                        children: [
                            navItemIcon && navItemIcon,
                            openNewTab && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__icons_chevronRight_mjs_c19fa3e7__["default"], {
                                className: (0, __WEBPACK_EXTERNAL_MODULE_clsx_lite_e67b6d69__["default"])(asPrimary && 'ptw-fill-primary-text'),
                                width: 24
                            })
                        ]
                    })
                ]
            }),
            subNavItems.length > 0 && showSubNav && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("ul", {
                className: "ptw-border-gray-50 ptw-mt-[-10px] ptw-max-h-[320px] ptw-list-none ptw-overflow-y-auto ptw-rounded ptw-border-thick ptw-border-t ptw-p-3 ptw-pt-4",
                children: subNavItems.map((subNavItem, i)=>renderChildMenuItem(subNavItem, i, subNavItems.length))
            })
        ]
    });
};
export { NavItem };
